import React, { useState } from 'react';
import './Gallery.css';

// Import your local images
import award1 from "../src/assets/1. Head Office Renovation .jpg";
import award2 from "../src/assets/DSCN0240.JPG";
import award3 from "../src/assets/3. Sullia Branch opening.jpg";
import award4 from "../src/assets/4. M S Road Branch OpeningPuttur.jpg";
import award5 from "../src/assets/MAH_2528.JPG";
import award6 from "../src/assets/6. Mangalore Branch Opening.jpg";
import award7 from "../src/assets/7. Sheshadripuram Branch Opening.JPG";
import award8 from "../src/assets/8. Belthangady Branch Opening.jpg";
import award9 from "../src/assets/9 Shirva Branch Opening.jpg";
import award10 from "../src/assets/DSC_1854.JPG";
import award11 from "../src/assets/11. BELLARE BRANCH.JPG";
import award12 from "../src/assets/IMG_1437.JPG";
import award13 from "../src/assets/IMG_1854.JPG";
import award15 from "../src/assets/DSCN0558.JPG";
import award16 from "../src/assets/16. Kikamba Branch Opening.jpeg";
import award17 from "../src/assets/DSCN1433.JPG";
import award18 from "../src/assets/20170423_104326.jpg";
import award19 from "../src/assets/19. Madanthyar Branch Opening.jpeg";
import award20 from "../src/assets/20. Mudipu Branch opening.JPG";
import award21 from "../src/assets/21. Kalladka Branch Opening.JPG";
import award22 from "../src/assets/Nehru Nagar Opening Image.JPG";
import award23 from "../src/assets/Siddakatte Branch Opening.JPG";
import award24 from "../src/assets/Ullal Branch Opening.JPG";
import Navbar from './Navbar';

const Gallery = () => {
  // Use the imported images with titles
  const images = [
    { id: 1, src: award1, alt: 'Head Office', title: 'Head Office Renovation' },
    { id: 2, src: award2, alt: 'Darbe Branch', title: 'Darbe Branch Opening' },
    { id: 3, src: award3, alt: 'Sullia Branch', title: 'Sullia Branch Opening' },
    { id: 4, src: award4, alt: 'M S Road Branch', title: 'M S Road Branch Opening, Puttur' },
    { id: 5, src: award5, alt: 'B C Road Branch', title: 'B C Road Branch Opening' },
    { id: 6, src: award6, alt: 'Mangalore Branch', title: 'Mangalore Branch Opening' },
    { id: 7, src: award7, alt: 'Sheshadripuram Branch', title: 'Sheshadripuram Branch Opening' },
    { id: 8, src: award8, alt: 'Belthangady Branch', title: 'Belthangady Branch Opening' },
    { id: 9, src: award9, alt: 'Shirva Branch', title: 'Shirva Branch Opening' },
    { id: 10, src: award10, alt: 'Jayanagara Branch', title: 'Jayanagara Branch Opening' },
    { id: 11, src: award11, alt: 'Bellare Branch', title: 'Bellare Branch Opening' },
    { id: 12, src: award12, alt: 'Kadaba Branch', title: 'Kadaba Branch Opening' },
    { id: 13, src: award13, alt: 'Vittal Branch', title: 'Vittal Branch Opening' },
    { id: 15, src: award15, alt: 'Dasarahalli Branch', title: 'Dasarahalli Branch Opening' },
    { id: 16, src: award16, alt: 'Gurupura Kaikamba Branch', title: 'Gurupura Kaikamba Branch Opening' },
    { id: 17, src: award17, alt: 'Surathkal Branch', title: 'Surathkal Branch Opening' },
    { id: 18, src: award18, alt: 'Machohalli Branch', title: 'Machohalli Branch Opening' },
    { id: 19, src: award19, alt: 'Madanthyar Branch', title: 'Madanthyar Branch Opening' },
    { id: 20, src: award20, alt: 'Mudipu Branch', title: 'Mudipu Branch Opening' },
    { id: 21, src: award21, alt: 'Kalladka Branch', title: 'Kalladka Branch Opening' },
    { id: 22, src: award22, alt: 'Nehru Nagar', title: 'Nehru Nagar Opening' },
    { id: 23, src: award23, alt: 'Siddakatte Branch', title: 'Siddakatte Branch Opening' },
    { id: 24, src: award24, alt: 'Ullal Branch', title: 'Ullal Branch Opening' },
  ];

  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImage = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const navigate = (direction) => {
    let newIndex;
    if (direction === 'prev') {
      newIndex = (currentIndex - 1 + images.length) % images.length;
    } else {
      newIndex = (currentIndex + 1) % images.length;
    }
    setSelectedImage(images[newIndex]);
    setCurrentIndex(newIndex);
  };

  return (
    <div className="gallery-page">
      <Navbar />
      <div className="gallery-container">
        <h1 className="gallery-title">Branch Opening Photos</h1>
        {/* <p className="gallery-subtitle">Celebrating our growth and expansion</p> */}

        <div className="gallery-grid">
          {images.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openImage(image, index)}
            >
              <div className="image-wrapper">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="image-title">{image.title}</div>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="image-popup">
            <div className="popup-backdrop" onClick={closeImage}></div>
            <div className="popup-content">
              <button className="close-btn" onClick={closeImage}>&times;</button>
              <div className="popup-image-container">
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="popup-image"
                />
                <div className="popup-title-container">
                  <h2 className="popup-title">{selectedImage.title}</h2>
                  <div className="image-counter">{currentIndex + 1} / {images.length}</div>
                </div>
              </div>
              <button
                className="nav-btn prev-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('prev');
                }}
              >
                &larr;
              </button>
              <button
                className="nav-btn next-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('next');
                }}
              >
                &rarr;
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;